<template>
  <div class="app-container">
    <div>
      <el-form :inline="true" ref="searchForm" :model="searchForm" class="search-form-inline">
        <el-form-item>
          <el-input v-model="searchForm.wx_nickname" placeholder="微信昵称" resize="horizontal" style="width: 152px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchForm.phone" :placeholder="generateCustomizeString('phone')" resize="horizontal" style="width: 155px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch()">{{ generateCustomizeString('search') }}</el-button>
          <el-button @click="onReset()">{{ generateCustomizeString('reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :data="memberData"
      v-loading="listLoading"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      style="margin-bottom: 20px;">
      <el-table-column :label="generateCustomizeString('phone')" prop="username">
      </el-table-column>
      <el-table-column
        label="邮箱"
        prop="email"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.email">
            {{ scope.row.email }}
          </div>
          <div v-else>
            <span>无</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="微信昵称" prop="wechatName">
      </el-table-column>
      <el-table-column :label="generateCustomizeString('memberLevel')" width="140">
        <template slot-scope="scope">
          <template v-if="scope.row.editStatus">
            <el-select v-model="scope.row.memberLevel" placeholder="会员等级">
              <el-option
                v-for="item in levelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select><br>
            <el-button type="success" size="small" icon="el-icon-circle-check-outline" @click="confirmEditLevel(scope.row, scope.row.memberLevel)" style="margin-top: 5px;">保存</el-button>
          </template>
          <span v-else>{{ scope.row.memberLevel }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="generateCustomizeString('memberCreateAt')" prop="registrationDate">
        <template slot-scope="scope">
          <span>{{ scope.row.registrationDate | toLocalTime }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="generateCustomizeString('remark')" width="140">
        <template slot-scope="scope">
          <template v-if="scope.row.editStatus">
            <el-input v-model="scope.row.remark" class="edit-input" size="small"/><br>
            <el-button type="success" size="small" icon="el-icon-circle-check-outline" @click="confirmEditRemark(scope.row, scope.row.remark)" style="margin-top: 5px;">保存</el-button>
          </template>
          <span v-else>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="generateCustomizeString('operation')" align="center" width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.editStatus">
            <!-- <el-button type="success" size="small" icon="el-icon-circle-check-outline" @click="confirmEdit(scope.row)">保存</el-button><br> -->
            <el-button class="cancel-btn" size="small" icon="el-icon-refresh" type="warning" @click="cancelEdit(scope.row)">取消</el-button>
          </template>
          <el-button v-else type="primary" size="small" icon="el-icon-edit" @click="scope.row.editStatus = !scope.row.editStatus">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-footer style="margin-top: 50px; width: 100%;">
      <el-row type="flex">
        <el-col>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfMembers"
            :total="currentTotal"
            small
            background
            layout="prev, pager, next"
            v-if="isMobile === true">
          </el-pagination>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfMembers"
            :total="currentTotal"
            background
            layout="total, prev, pager, next"
            v-else>
          </el-pagination>
        </el-col>
      </el-row>
    </el-footer>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

const originMemberSearchFrom = {
  wx_nickname: '',
  phone: ''
}

export default {
  name: 'MemberList',
  data() {
    return {
      listLoading: true,
      currentPage: 1,
      currentTotal: 0,
      numOfMembers: 15,
      searchForm: Object.assign({}, originMemberSearchFrom),
      filters: {},
      isMobile: false,
      levelOptions: [],
      memberData: []
    }
  },
  created() {
    Promise.all([
      this.checkMobile(),
      this.fetchAllLevels()
    ])
      .then(result => {
        this.fetchMemberData(1)
      })
      .catch(error => {
        console.warn(error)
      })
  },
  methods: {
    generateCustomizeString,
    onSearch() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.searchForm)
          this.filters = params
          this.fetchMemberData(1)
        } else {
          console.log('data error')
        }
      })
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.searchForm = Object.assign({}, originMemberSearchFrom)
      this.filters = {}
      this.fetchMemberData(1)
    },
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
    },
    handleCurrentChange(val) {
      this.fetchMemberData(val)
    },
    fetchAllLevels() {
      return new Promise((resolve, reject) => {
        request({
          url: 'discount/level/list',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].level
              obj.label = response.data[i].name
              data[i] = obj
            }
            this.levelOptions = data
            console.log(this.levelOptions)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchMemberData(page) {
      return new Promise((resolve, reject) => {
        request({
          url: '/customer-list',
          method: 'get',
          params: {
            page: page,
            ...this.filters,
            page_size: this.numOfMembers
          }
        })
          .then(response => {
            const data = response.data
            const meta = response.meta
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.id = response.data[i].id
              obj.memberId = response.data[i].id
              obj.username = response.data[i].phone
              obj.email = response.data[i].email
              obj.remark = response.data[i].remark
              if (response.data[i].wechat_auths.length && response.data[i].wechat_auths[0].user_info) {
                obj.headimgurl = response.data[i].wechat_auths[0].user_info['headimgurl']
                obj.wechatName = response.data[i].wechat_auths[0].user_info['nickname']
              } else {
                obj.wechatName = '无'
              }
              if (response.data[i].points) {
                if (response.data[i].points.level_info) {
                  obj.memberLevel = response.data[i].points.level_info.name
                  // this.memberLevel = response.data[i].points.level_info.name
                } else {
                  obj.memberLevel = '无'
                  // this.memberLevel = '无'
                }
              } else {
                obj.memberLevel = '无'
              }
              if (response.data[i].created_at) {
                obj.registrationDate = response.data[i].created_at
              }
              obj.editStatus = false

              data[i] = obj
            }

            this.memberData = data
            this.currentPage = meta.current_page
            this.currentTotal = meta.total

            this.listLoading = false
            resolve()
          })
          .catch(error => {
            console.warn(error)
            this.listLoading = false
            reject(error)
          })
      })
    },
    cancelEdit(row) {
      row.editStatus = false
    },
    confirmEditRemark(row, remark) {
      var data = {
        remark: remark
      }
      request({
        url: 'customer/' + row.id + '/remark',
        method: 'patch',
        data
      })
        .then(response => {
          if (response.status === 0) {
            this.$message({
              message: '会员备注更改成功',
              type: 'success',
              center: true
            })
          } else {
            this.$message.error({
              message: '会员备注更改失败',
              center: true
            })
          }
          this.fetchMemberData()

          row.editStatus = false
        })
        .catch(error => {
          console.log(error)
          this.$message.error({
            message: '会员备注更改失败',
            center: true
          })
          row.editStatus = false
        })
    },
    confirmEditLevel(row, level) {
      request({
        url: 'customer/' + row.id + '/level',
        method: 'patch',
        data: {
          level
        }
      }).then(response => {
        if (response.status === 0) {
          this.$message({
            message: '会员等级更改成功',
            type: 'success',
            center: true
          })
        } else {
          this.$message.error({
            message: '会员等级更改失败',
            center: true
          })
        }
        this.fetchMemberData(this.currentPage)
        row.editStatus = false
      }).catch(error => {
        console.warn(error)
        this.$message.error({
          message: '会员等级更改失败',
          center: true
        })
        row.editStatus = false
      })
    }
  }
}
</script>
